import _slicedToArray from "/home/runner/work/help/help/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from "tslib";
/* eslint-disable no-console */

import * as React from 'react';
import { KEY_CODES } from '../../helpers/constants';
import styles from '@patternfly/react-styles/css/components/Popover/popover';
import { css } from '@patternfly/react-styles';
import { PopoverContext } from './PopoverContext';
import { PopoverContent } from './PopoverContent';
import { PopoverBody } from './PopoverBody';
import { PopoverHeader } from './PopoverHeader';
import { PopoverFooter } from './PopoverFooter';
import { PopoverCloseButton } from './PopoverCloseButton';
import { PopoverArrow } from './PopoverArrow';
import popoverMaxWidth from '@patternfly/react-tokens/dist/esm/c_popover_MaxWidth';
import popoverMinWidth from '@patternfly/react-tokens/dist/esm/c_popover_MinWidth';
import { FocusTrap } from '../../helpers';
import { Popper, getOpacityTransition } from '../../helpers/Popper/Popper';
import { getUniqueId } from '../../helpers/util';
export var PopoverPosition;

(function (PopoverPosition) {
  PopoverPosition["auto"] = "auto";
  PopoverPosition["top"] = "top";
  PopoverPosition["bottom"] = "bottom";
  PopoverPosition["left"] = "left";
  PopoverPosition["right"] = "right";
  PopoverPosition["topStart"] = "top-start";
  PopoverPosition["topEnd"] = "top-end";
  PopoverPosition["bottomStart"] = "bottom-start";
  PopoverPosition["bottomEnd"] = "bottom-end";
  PopoverPosition["leftStart"] = "left-start";
  PopoverPosition["leftEnd"] = "left-end";
  PopoverPosition["rightStart"] = "right-start";
  PopoverPosition["rightEnd"] = "right-end";
})(PopoverPosition || (PopoverPosition = {}));

var alertStyle = {
  default: styles.modifiers.default,
  info: styles.modifiers.info,
  success: styles.modifiers.success,
  warning: styles.modifiers.warning,
  danger: styles.modifiers.danger
};
export var Popover = function Popover(_a) {
  var children = _a.children,
      _a$position = _a.position,
      position = _a$position === void 0 ? 'top' : _a$position,
      _a$enableFlip = _a.enableFlip,
      enableFlip = _a$enableFlip === void 0 ? true : _a$enableFlip,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$isVisible = _a.isVisible,
      isVisible = _a$isVisible === void 0 ? null : _a$isVisible,
      _a$shouldClose = _a.shouldClose,
      shouldClose = _a$shouldClose === void 0 ? function () {
    return null;
  } : _a$shouldClose,
      _a$shouldOpen = _a.shouldOpen,
      shouldOpen = _a$shouldOpen === void 0 ? function () {
    return null;
  } : _a$shouldOpen,
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      bodyContent = _a.bodyContent,
      _a$headerContent = _a.headerContent,
      headerContent = _a$headerContent === void 0 ? null : _a$headerContent,
      _a$headerComponent = _a.headerComponent,
      headerComponent = _a$headerComponent === void 0 ? 'h6' : _a$headerComponent,
      _a$headerIcon = _a.headerIcon,
      headerIcon = _a$headerIcon === void 0 ? null : _a$headerIcon,
      alertSeverityVariant = _a.alertSeverityVariant,
      alertSeverityScreenReaderText = _a.alertSeverityScreenReaderText,
      _a$footerContent = _a.footerContent,
      footerContent = _a$footerContent === void 0 ? null : _a$footerContent,
      _a$appendTo = _a.appendTo,
      appendTo = _a$appendTo === void 0 ? function () {
    return document.body;
  } : _a$appendTo,
      _a$hideOnOutsideClick = _a.hideOnOutsideClick,
      hideOnOutsideClick = _a$hideOnOutsideClick === void 0 ? true : _a$hideOnOutsideClick,
      _a$onHide = _a.onHide,
      onHide = _a$onHide === void 0 ? function () {
    return null;
  } : _a$onHide,
      _a$onHidden = _a.onHidden,
      onHidden = _a$onHidden === void 0 ? function () {
    return null;
  } : _a$onHidden,
      _a$onShow = _a.onShow,
      onShow = _a$onShow === void 0 ? function () {
    return null;
  } : _a$onShow,
      _a$onShown = _a.onShown,
      onShown = _a$onShown === void 0 ? function () {
    return null;
  } : _a$onShown,
      _a$onMount = _a.onMount,
      onMount = _a$onMount === void 0 ? function () {
    return null;
  } : _a$onMount,
      _a$zIndex = _a.zIndex,
      zIndex = _a$zIndex === void 0 ? 9999 : _a$zIndex,
      _a$minWidth = _a.minWidth,
      minWidth = _a$minWidth === void 0 ? popoverMinWidth && popoverMinWidth.value : _a$minWidth,
      _a$maxWidth = _a.maxWidth,
      maxWidth = _a$maxWidth === void 0 ? popoverMaxWidth && popoverMaxWidth.value : _a$maxWidth,
      _a$closeBtnAriaLabel = _a.closeBtnAriaLabel,
      closeBtnAriaLabel = _a$closeBtnAriaLabel === void 0 ? 'Close' : _a$closeBtnAriaLabel,
      _a$showClose = _a.showClose,
      showClose = _a$showClose === void 0 ? true : _a$showClose,
      _a$distance = _a.distance,
      distance = _a$distance === void 0 ? 25 : _a$distance,
      _a$flipBehavior = _a.flipBehavior,
      flipBehavior = _a$flipBehavior === void 0 ? ['top', 'right', 'bottom', 'left', 'top', 'right', 'bottom'] : _a$flipBehavior,
      _a$animationDuration = _a.animationDuration,
      animationDuration = _a$animationDuration === void 0 ? 300 : _a$animationDuration,
      id = _a.id,
      propWithFocusTrap = _a.withFocusTrap,
      boundary = _a.boundary,
      tippyProps = _a.tippyProps,
      reference = _a.reference,
      _a$hasNoPadding = _a.hasNoPadding,
      hasNoPadding = _a$hasNoPadding === void 0 ? false : _a$hasNoPadding,
      _a$hasAutoWidth = _a.hasAutoWidth,
      hasAutoWidth = _a$hasAutoWidth === void 0 ? false : _a$hasAutoWidth,
      rest = __rest(_a, ["children", "position", "enableFlip", "className", "isVisible", "shouldClose", "shouldOpen", 'aria-label', "bodyContent", "headerContent", "headerComponent", "headerIcon", "alertSeverityVariant", "alertSeverityScreenReaderText", "footerContent", "appendTo", "hideOnOutsideClick", "onHide", "onHidden", "onShow", "onShown", "onMount", "zIndex", "minWidth", "maxWidth", "closeBtnAriaLabel", "showClose", "distance", "flipBehavior", "animationDuration", "id", "withFocusTrap", "boundary", "tippyProps", "reference", "hasNoPadding", "hasAutoWidth"]);

  if (process.env.NODE_ENV !== 'production') {
    boundary !== undefined && console.warn('The Popover boundary prop has been deprecated. If you want to constrain the popper to a specific element use the appendTo prop instead.');
    tippyProps !== undefined && console.warn('The Popover tippyProps prop has been deprecated and is no longer used.');
  } // could make this a prop in the future (true | false | 'toggle')
  // const hideOnClick = true;


  var uniqueId = id || getUniqueId();
  var triggerManually = isVisible !== null;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      visible = _React$useState2[0],
      setVisible = _React$useState2[1];

  var _React$useState3 = React.useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      opacity = _React$useState4[0],
      setOpacity = _React$useState4[1];

  var _React$useState5 = React.useState(Boolean(propWithFocusTrap)),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      focusTrapActive = _React$useState6[0],
      setFocusTrapActive = _React$useState6[1];

  var transitionTimerRef = React.useRef(null);
  var showTimerRef = React.useRef(null);
  var hideTimerRef = React.useRef(null);
  React.useEffect(function () {
    onMount();
  }, []);
  React.useEffect(function () {
    if (triggerManually) {
      if (isVisible) {
        show();
      } else {
        hide();
      }
    }
  }, [isVisible, triggerManually]);

  var show = function show(withFocusTrap) {
    onShow();

    if (transitionTimerRef.current) {
      clearTimeout(transitionTimerRef.current);
    }

    if (hideTimerRef.current) {
      clearTimeout(hideTimerRef.current);
    }

    showTimerRef.current = setTimeout(function () {
      setVisible(true);
      setOpacity(1);
      propWithFocusTrap !== false && withFocusTrap && setFocusTrapActive(true);
      onShown();
    }, 0);
  };

  var hide = function hide() {
    onHide();

    if (showTimerRef.current) {
      clearTimeout(showTimerRef.current);
    }

    hideTimerRef.current = setTimeout(function () {
      setVisible(false);
      setOpacity(0);
      setFocusTrapActive(false);
      transitionTimerRef.current = setTimeout(function () {
        onHidden();
      }, animationDuration);
    }, 0);
  };

  var positionModifiers = {
    top: styles.modifiers.top,
    bottom: styles.modifiers.bottom,
    left: styles.modifiers.left,
    right: styles.modifiers.right,
    'top-start': styles.modifiers.topLeft,
    'top-end': styles.modifiers.topRight,
    'bottom-start': styles.modifiers.bottomLeft,
    'bottom-end': styles.modifiers.bottomRight,
    'left-start': styles.modifiers.leftTop,
    'left-end': styles.modifiers.leftBottom,
    'right-start': styles.modifiers.rightTop,
    'right-end': styles.modifiers.rightBottom
  };
  var hasCustomMinWidth = minWidth !== popoverMinWidth.value;
  var hasCustomMaxWidth = maxWidth !== popoverMaxWidth.value;

  var onDocumentKeyDown = function onDocumentKeyDown(event) {
    if (event.keyCode === KEY_CODES.ESCAPE_KEY && visible) {
      if (triggerManually) {
        shouldClose(null, hide, event);
      } else {
        hide();
      }
    }
  };

  var onDocumentClick = function onDocumentClick(event, triggerElement, popperElement) {
    if (hideOnOutsideClick && visible) {
      // check if we clicked within the popper, if so don't do anything
      var isChild = popperElement && popperElement.contains(event.target);

      if (isChild) {
        // clicked within the popper
        return;
      }

      if (triggerManually) {
        shouldClose(null, hide, event);
      } else {
        hide();
      }
    }
  };

  var onTriggerClick = function onTriggerClick(event) {
    if (triggerManually) {
      if (visible) {
        shouldClose(null, hide, event);
      } else {
        shouldOpen(show, event);
      }
    } else {
      if (visible) {
        hide();
      } else {
        show(true);
      }
    }
  };

  var onContentMouseDown = function onContentMouseDown() {
    if (focusTrapActive) {
      setFocusTrapActive(false);
    }
  };

  var closePopover = function closePopover(event) {
    event.stopPropagation();

    if (triggerManually) {
      shouldClose(null, hide, event);
    } else {
      hide();
    }
  };

  var content = React.createElement(FocusTrap, Object.assign({
    active: focusTrapActive,
    focusTrapOptions: {
      returnFocusOnDeactivate: true,
      clickOutsideDeactivates: true,
      tabbableOptions: {
        displayCheck: 'none'
      },
      fallbackFocus: function fallbackFocus() {
        // If the popover's trigger is focused but scrolled out of view,
        // FocusTrap will throw an error when the Enter button is used on the trigger.
        // That is because the Popover is hidden when its trigger is out of view.
        // Provide a fallback in that case.
        var node = null;

        if (document && document.activeElement) {
          node = document.activeElement;
        }

        return node;
      }
    },
    preventScrollOnDeactivate: true,
    className: css(styles.popover, alertSeverityVariant && alertStyle[alertSeverityVariant], hasNoPadding && styles.modifiers.noPadding, hasAutoWidth && styles.modifiers.widthAuto, className),
    role: "dialog",
    "aria-modal": "true",
    "aria-label": headerContent ? undefined : ariaLabel,
    "aria-labelledby": headerContent ? "popover-".concat(uniqueId, "-header") : undefined,
    "aria-describedby": "popover-".concat(uniqueId, "-body"),
    onMouseDown: onContentMouseDown,
    style: {
      minWidth: hasCustomMinWidth ? minWidth : null,
      maxWidth: hasCustomMaxWidth ? maxWidth : null,
      opacity: opacity,
      transition: getOpacityTransition(animationDuration)
    }
  }, rest), React.createElement(PopoverArrow, null), React.createElement(PopoverContent, null, showClose && React.createElement(PopoverCloseButton, {
    onClose: closePopover,
    "aria-label": closeBtnAriaLabel
  }), headerContent && React.createElement(PopoverHeader, {
    id: "popover-".concat(uniqueId, "-header"),
    icon: headerIcon,
    alertSeverityVariant: alertSeverityVariant,
    alertSeverityScreenReaderText: alertSeverityScreenReaderText || "".concat(alertSeverityVariant, " alert:"),
    titleHeadingLevel: headerComponent
  }, typeof headerContent === 'function' ? headerContent(hide) : headerContent), React.createElement(PopoverBody, {
    id: "popover-".concat(uniqueId, "-body")
  }, typeof bodyContent === 'function' ? bodyContent(hide) : bodyContent), footerContent && React.createElement(PopoverFooter, {
    id: "popover-".concat(uniqueId, "-footer")
  }, typeof footerContent === 'function' ? footerContent(hide) : footerContent)));
  return React.createElement(PopoverContext.Provider, {
    value: {
      headerComponent: headerComponent
    }
  }, React.createElement(Popper, {
    trigger: children,
    reference: reference,
    popper: content,
    popperMatchesTriggerWidth: false,
    appendTo: appendTo,
    isVisible: visible,
    positionModifiers: positionModifiers,
    distance: distance,
    placement: position,
    onTriggerClick: onTriggerClick,
    onDocumentClick: onDocumentClick,
    onDocumentKeyDown: onDocumentKeyDown,
    enableFlip: enableFlip,
    zIndex: zIndex,
    flipBehavior: flipBehavior
  }));
};
Popover.displayName = 'Popover';